import { put, call, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    GET_ALL_EMPLOIS_REQUEST, getAllEmploisSuccess, getAllEmploisFail,
    GET_EMPLOI_REQUEST, getEmploiSuccess, getEmploiFail,
    CREATE_EMPLOI_REQUEST, createEmploiSuccess, createEmploiFail,
    UPDATE_EMPLOI_REQUEST, updateEmploiSuccess, updateEmploiFail,
    DELETE_EMPLOI_REQUEST, deleteEmploiSuccess, deleteEmploiFail
} from "../actions/emploiActions";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

export function* getAllEmploisSaga() {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/emplois`;
    try {
        const resp = yield call(getRequest, { url, token, extraHeaders: { uid } });
        yield put(getAllEmploisSuccess(resp.data));
    } catch (error) {
        yield put(getAllEmploisFail(error.message));
    }
}

export function* getEmploiSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/emplois/${action.payload}`;
    try {
        const resp = yield call(getRequest, { url, token, extraHeaders: { uid } });
        yield put(getEmploiSuccess(resp.data));
    } catch (error) {
        yield put(getEmploiFail(error.message));
    }
}

export function* createEmploiSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/emplois`;
    try {
        const resp = yield call(postRequest, { url, data: action.payload, token, extraHeaders: { uid } });
        yield put(createEmploiSuccess(resp.data));
        Swal.fire({ icon: 'success', title: 'Succès', text: 'Emploi créé avec succès !' });
        if (action.callback) action.callback();
    } catch (error) {
        const errorMsg = error.response?.data?.message || error.message;
        yield put(createEmploiFail(errorMsg));
        Swal.fire({ icon: 'error', title: 'Erreur', text: errorMsg });
    }
}

export function* updateEmploiSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const { id, emploi } = action.payload;
    const url = `${API_BASE_URL}/api/emplois/${id}`;
    try {
        const resp = yield call(putRequest, { url, data: emploi, token, extraHeaders: { uid } });
        yield put(updateEmploiSuccess(resp.data));
        Swal.fire({ icon: 'success', title: 'Succès', text: 'Emploi modifié avec succès !' });
        if (action.callback) action.callback();
    } catch (error) {
        const errorMsg = error.response?.data?.message || error.message;
        yield put(updateEmploiFail(errorMsg));
        Swal.fire({ icon: 'error', title: 'Erreur', text: errorMsg });
    }
}

export function* deleteEmploiSaga(action) {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    const url = `${API_BASE_URL}/api/emplois/${action.payload}`;
    try {
        yield call(deleteRequest, { url, token, extraHeaders: { uid } });
        yield put(deleteEmploiSuccess(action.payload));
        Swal.fire({ icon: 'success', title: 'Succès', text: 'Emploi supprimé avec succès !' });
    } catch (error) {
        yield put(deleteEmploiFail(error.message));
        Swal.fire({ icon: 'error', title: 'Erreur', text: 'Impossible de supprimer cet emploi' });
    }
}

export default function* watchEmploiSagas() {
    yield takeLatest(GET_ALL_EMPLOIS_REQUEST, getAllEmploisSaga);
    yield takeLatest(GET_EMPLOI_REQUEST, getEmploiSaga);
    yield takeLatest(CREATE_EMPLOI_REQUEST, createEmploiSaga);
    yield takeLatest(UPDATE_EMPLOI_REQUEST, updateEmploiSaga);
    yield takeLatest(DELETE_EMPLOI_REQUEST, deleteEmploiSaga);
}
